export interface DisableWidgetConfigAction {
  type: "SEND_MESSAGE_TO_MERCHANT";
  payload: {
    type: "DISABLE_WIDGET_CONFIG";
    data: { widgetConfigId: string };
  };
}

export function disableWidgetConfig(
  widgetConfigId: string
): DisableWidgetConfigAction {
  return {
    type: "SEND_MESSAGE_TO_MERCHANT",
    payload: {
      type: "DISABLE_WIDGET_CONFIG",
      data: { widgetConfigId },
    },
  };
}
